import axios from '@/plugins/http'

export const updateProduct = ({ storeSlug, productId, data }) => (
  axios.put(`/api/v1/stores/${storeSlug}/products/${productId}`, data)
)
